import styled from '@emotion/styled';

export const ProjectTitle = styled.h2`
  font-weight: 600;
  font-size: 83px;
  line-height: 110%;
  color: #fff;
  margin-bottom: 20px;

  span {
    color: #d3f500;
  }

  @media (min-width: 1440px) {
    position: absolute;
    top: 271px;
    left: 41px;
    font-size: 136px;
    max-width: 660px;
  }
`;
